export default __webpack_public_path__ + "static/media/ic_cambodia.75b6773e.svg";